import React from 'react'
import PropTypes from 'prop-types'

import Modal from './Modal'

// const APP_PREFIX = '(App)'
// const WEB_PREFIX = '(Web)'

const ViewModal = ({
  closeModal = () => {},
  record: { dsProfile, lsMenus, type = 2 },
  translate = () => {},
}) => {
  const orderedPermissions = lsMenus.sort((a, b) => {
    if (a.cdMenuParent < b.cdMenuParent) return -1
    if (a.cdMenuParent > b.cdMenuParent) return 1
    return 0
  })

  let webPermissions = ''
  for (const item of orderedPermissions) {
    if (item.tipShow === 2) {
      if (item.cdMenuParent !== null && item.dsMenuParent !== '') {
        webPermissions += `[ ${translate(
          item.dsMenuParentNotTranslated
        )} >> ${translate(item.dsMenuNotTranslated)} ] `
      } else {
        webPermissions += `[ ${translate(item.dsMenuNotTranslated)} ] `
      }
    }
  }

  let appPermissions = ''
  for (const item of orderedPermissions) {
    if (item.tipShow === 1) {
      if (item.cdMenuParent !== null && item.dsMenuParent !== '') {
        appPermissions += `[ ${item.dsMenuParent} >> ${item.dsMenu} ] `
      } else {
        appPermissions += `[ ${item.dsMenu} ] `
      }
    }
  }
  return (
    <Modal
      renderButton={false}
      title={translate(`missionMenu.viewModal.title.${type}`)}
      onCloseModal={closeModal}
      center={false}
      isOpen
      size='lg'
      className='mission-block-edit-modal'
    >
      <em className='item-light left w-100'>
        {translate(`missionMenu.viewModal.name.${type}`)}
      </em>
      <em className='left margin-bottom margin-top w-100'>{dsProfile}</em>
      <em className='item-light left w-100'>
        {translate('missionMenu.viewModal.webPermissions')}
      </em>
      <em className='left margin-bottom margin-top w-100'>
        {webPermissions || '-'}
      </em>
      <em className='item-light left w-100'>
        {translate('missionMenu.viewModal.appPermissions')}
      </em>
      <em className='left margin-bottom margin-top w-100'>
        {appPermissions || '-'}
      </em>
    </Modal>
  )
}

ViewModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  record: PropTypes.object.isRequired,
  translate: PropTypes.func.isRequired,
  type: PropTypes.number,
}

export default ViewModal
